import { type AggRequest, type AggResponse, fetchAgg } from '../../../../../common/utils/fetch-agg';

const operationName = 'AutoSuggestionQuery';

const AutoSuggestionQuery = `
query ${operationName}($query: String, $limit: Int!, $filters: QuerySuggestionFilterInput!) {
  suggest {
    suggest(query: $query, limit: $limit, filters: $filters) {
      nodes {
        title
        type
      }
      totalCount
    }
  }
}
`;

export type AutoSuggestionQueryVariables = {
	query?: string;
	limit: number;
	filters: QuerySuggestionFilterInput;
};

export type AutoSuggestionAPI = {
	suggest: {
		suggest: AutoSuggestionNodes;
	};
};

export type AutoSuggestionNodes = {
	nodes: Array<AutoSuggestionResult>;
	totalCount: number;
};

export type AutoSuggestionResult = {
	title: string;
	type: string;
};

export type QuerySuggestionFilterInput = {
	entities: string[];
	locations: string[];
};

export type AutoSuggestionQueryProps = Pick<
	AggRequest<AutoSuggestionQueryVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

export const autoSuggestionQuery: ({
	variables,
	aggAbsoluteUrl,
	headers,
}: AutoSuggestionQueryProps) => Promise<AggResponse<AutoSuggestionAPI>> = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: AutoSuggestionQueryProps) =>
	fetchAgg<AutoSuggestionQueryVariables, AutoSuggestionAPI>({
		variables,
		aggAbsoluteUrl,
		graphQuery: AutoSuggestionQuery,
		operationName,
		headers,
	});
